<!-- Button -->
<div
    class="expansion-panel-header"
    [style.padding-left.px]="headerLeftPadding"
    [style.margin-top.px]="marginTopHeader"
    [class.no-bottom-border]="borderBottomRemoved"
    [class.secondary-color-light-background]="backgroundColor === secondaryColorLight"
    [class.secondary-color-background]="backgroundColor === secondaryColor"
    [class.transparent-background]="backgroundColor === transparentColor"
    [class.no-border]="noBorder"
    [ngClass]="expansionPanelIconStyle">
    <span role="heading" [attr.aria-level]="headerLevel" [attr.id]="'expansion-panel-title-' + expansionPanelId">
        <ng-container *ngTemplateOutlet="expansionPanelButton"></ng-container>
    </span>
</div>
<!-- Content -->
<div
    [@expandCollapseAnimation]="{
        value: collapsed ? 'closed' : 'open',
        params: { duration: animationDuration }
    }"
    (@expandCollapseAnimation.done)="onAnimationEnd($event)">
    <div
        #expansionPanelContent
        [style.padding]="contentPadding"
        [class.border-bottom]="borderBottomContent"
        [attr.id]="'expansion-panel-content-' + expansionPanelId"
        [attr.role]="role === 'accordion' ? 'region' : null"
        [attr.aria-labelledby]="role === 'accordion' ? 'expansion-panel-header-text-' + expansionPanelId : null"
        [class.secondary-color-light-background]="backgroundColor === secondaryColorLight"
        [class.secondary-color-background]="backgroundColor === secondaryColor"
        [class.transparent-background]="backgroundColor === transparentColor"
        class="expansion-panel-content">
        <ng-container [ngTemplateOutlet]="contentRef"></ng-container>
    </div>
</div>

<!-- Button template -->
<ng-template #expansionPanelButton>
    @if (collapsable) {
    <button
        [ngClass]="{ expansionPanelIconStyle: true, 'no-padding': noPaddingHeader }"
        [attr.aria-controls]="'expansion-panel-content-' + expansionPanelId"
        [attr.aria-expanded]="!collapsed"
        [attr.aria-describedby]="buttonDescription ? 'described-by-' + expansionPanelId : null"
        [attr.data-testid]="dataTestId"
        class="expansion-panel-header-button"
        [class.keyboard-navigation]="layoutFacade.keyboardNavigation$ | async"
        [class.apply-focus-offset]="applyFocusOffset"
        [class.font-size-text-large]="isHeaderFontSizeLarge"
        [class.small-min-height]="hasButtonSmallMinHeight"
        [class.no-outline-offset]="noOutlineOffset"
        type="button"
        (click)="handleHeaderExpansionPanel()"
        (keypress.enter)="handleHeaderExpansionPanel()">
        <ng-container *ngTemplateOutlet="expansionPanelHeader"></ng-container>
    </button>
    } @if (buttonDescription) {
    <p [id]="'described-by-' + expansionPanelId" class="sr-only"> &nbsp;{{ buttonDescription }}&nbsp; </p>
    } @if (!collapsable) {
    <div
        class="expansion-panel-header-button"
        [class.keyboard-navigation]="layoutFacade.keyboardNavigation$ | async"
        [class.apply-focus-offset]="applyFocusOffset">
        <ng-container *ngTemplateOutlet="expansionPanelHeader"></ng-container>
    </div>
    }
</ng-template>

<!-- Header template -->
<ng-template #expansionPanelHeader>
    <span
        [id]="'expansion-panel-header-text-' + expansionPanelId"
        class="expansion-panel-header-text"
        [class.font-black-color]="hasBlackFontColor">
        <ng-container [ngTemplateOutlet]="titleRef"></ng-container>
    </span>
    <span class="expansion-panel-header-spacer"></span>
    <span class="expansion-panel-header-right-part" [ngClass]="{ clickable: !collapsable }">
        @if (expansionPanelRef) {
        <div
            class="expansion-panel-header-right-part-text"
            [ngClass]="{ 'expansion-panel-header-right-part-with-text-icon': hasExpansionPanelIcon }">
            <ng-container *ngTemplateOutlet="expansionPanelRef"></ng-container>
        </div>
        @if (hasExpansionPanelIcon) {
        <div class="expansion-panel-header-right-part-icon">
            <ng-container *ngTemplateOutlet="iconExpansionPanel"></ng-container>
        </div>
        } } @else {
        <h-expansion-panel-icon
            class="expansion-panel-icon"
            [collapsed]="collapsed"
            [showIcon]="showIcon"
            [expansionPanelStyle]="expansionPanelIconStyle"
            [shouldPlusMinusSvgHaveSmallDimensions]="shouldPlusMinusSvgHaveSmallDimensions"
            [shouldPlusMinusSvgHavePrimaryDarkStroke]="shouldPlusMinusSvgHavePrimaryDarkStroke"
            [shouldPlusMinusSvgHaveSmallStrokeWidth]="shouldPlusMinusSvgHaveSmallStrokeWidth"></h-expansion-panel-icon>
        }
        <ng-template #iconExpansionPanel>
            <h-expansion-panel-icon
                class="expansion-panel-icon"
                [collapsed]="collapsed"
                [showIcon]="showIcon"
                [expansionPanelStyle]="expansionPanelIconStyle"></h-expansion-panel-icon>
        </ng-template>
    </span>
</ng-template>
